module.exports = __webpack_public_path__ + "00fba9668a3f719512c366ca9e2582f5.svg";